// extracted by mini-css-extract-plugin
export default {"container":"Button_container__XDNIn","link":"Button_link__aT91l","text":"Button_text__uItJa","loadingIndicator":"Button_loadingIndicator__NB8nj"};